/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/ARMEndpointVerificationComponent" />
import React = require("react");
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { ServiceEndpointRequestResult } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { announce } from "VSS/Core/Util/Accessibility";
import { ServiceEndpointsSource } from "DistributedTaskUI/ServiceEndpoints/Editor/Source/ServiceEndpointsSource";

interface IARMEndpointVerificationComponentProps {
    disabled: boolean;
}
interface IARMEndpointVerificationComponentState {
    isVerifyInProgress: boolean;
    errorMessage?: string;
    isVerificationSuccess?: boolean;
}

export class ARMEndpointVerificationComponent extends VssComponent<IARMEndpointVerificationComponentProps, IARMEndpointVerificationComponentState> {

    private readonly _endpointEditorStore: EndpointsEditorStore;
    private readonly _source: ServiceEndpointsSource;
    private readonly _endpointEditorActionCreator: EndpointsEditorActionsCreator;


    constructor(props: IARMEndpointVerificationComponentProps, context: IVssComponentContext) {
        super(props, context);

        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        this._endpointEditorStore.addChangedListener(this._endpointEditorStoreChanged);

        this._source = ServiceEndpointsSource.getInstance(context.pageContext);
        this._endpointEditorActionCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(EndpointsEditorActionsCreator, ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId);

        this.state = {
            isVerifyInProgress: false
        };
    }

    public componentWillUnmount(): void {
        this._endpointEditorStore.removeChangedListener(this._endpointEditorStoreChanged);
    }

    public render(): JSX.Element {
        const isVerifyInProgress = this.state.isVerifyInProgress;
        const isVerificationDisabled = isVerifyInProgress || this.props.disabled;
        const isVerificationSuccess = this.state.isVerificationSuccess;
        const errorMessage = this.state.errorMessage;
        return (
            <div className={"flex-row default-input-margin-top"}>
                {EndpointsEditorPanelUtils.getVerifyButton(isVerificationDisabled, this._verifyEndpoint)}
                {EndpointsEditorPanelUtils.getVerificationDetails(isVerifyInProgress, isVerificationSuccess, errorMessage)}
            </div>
        );
    }

    private _endpointEditorStoreChanged = (): void => {
        const state = this._endpointEditorStore.getState();

        if (!state.isError) {
            this.setState({
                isVerificationSuccess: undefined,
                errorMessage: undefined
            });
        }
    }

    private _verifyEndpoint = (): void => {
        this._endpointEditorActionCreator.clearErrorDetails();
        this.updateVerificationStatus(true);
        this.verifyConnection().then((result) => {
            this.updateVerificationStatus(false, result.errorMessage, result.activityId);
        }).catch((error) => {
            const errorMessage = error.message ? error.message : Resources.ValidateEndpointErrorMessage;
            this.updateVerificationStatus(false, errorMessage);
        });
    }

    private verifyConnection(): Promise<ServiceEndpointRequestResult> {
        const endpoint = this._endpointEditorStore.getEndpointClone();
        const serviceEndpointRequest = EndpointsEditorPanelUtils.getServiceEndpointRequestForTest(endpoint);
        return this._source.verifyServiceEndpoint(serviceEndpointRequest, endpoint.id);
    }

    private updateVerificationStatus(isVerifyInProgress: boolean, errorMessage?: string, activityId?: string): void {
        if (errorMessage) {
            announce(errorMessage);
            this._endpointEditorActionCreator.setErrorDetails({
                activityId: activityId,
                errorMessage: errorMessage,
                isError: true
            });
        }

        this.setState({
            isVerifyInProgress: isVerifyInProgress,
            errorMessage: errorMessage,
            isVerificationSuccess: !errorMessage
        });
    }
}
